import Fetcher from '../../../../services/Fetcher'
import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination,
  TOptionsResponse
} from '../../../../constants'
import { RebateTierRequest } from './MarketShareRebateCondition/types'

const fetcher = new Fetcher({})

export const getThresholdPeriods = async (id: string) =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.CONTRACTS}${id}/${API_DICTIONARY.REBATE}${API_DICTIONARY.OPTIONS}${API_DICTIONARY.PERIOD_THRESHOLD}`,
    method: HTTP_METHODS.GET
  })

const getRebateTiersUrl = (contractId: string, rebateId: string) =>
  `${API_DICTIONARY.CONTRACTS}${contractId}/${API_DICTIONARY.REBATE}${rebateId}/${API_DICTIONARY.TIERS}`

export const getRebateTiersRequest = async (
  contractId: string,
  rebateId: string
) =>
  fetcher.request<unknown, RebateTierRequest[]>({
    url: getRebateTiersUrl(contractId, rebateId),
    method: HTTP_METHODS.GET
  })

export const updateRebateTiersRequest = async (
  contractId: string,
  rebateId: string,
  tiers: { tiers: RebateTierRequest[] }
) =>
  fetcher.request<
    { tiers: RebateTierRequest[] },
    { tiers: RebateTierRequest[] }
  >({
    url: getRebateTiersUrl(contractId, rebateId),
    method: HTTP_METHODS.POST,
    data: tiers
  })
